"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backToTopId = exports.classes = void 0;
var classes = {
  secretsManagerContainer: 'manage-my-secrets-container',
  secretsPoliciesTabsContainer: 'secrets-policies-tabs-container',
  secretsTabTableContainer: 'secrets-tab-table-container',
  nodesSecretsTreeContainer: 'nodes-secrets-tree-container',
  secretsEyeIcon: 'secrets-eye-icon'
};
exports.classes = classes;
var backToTopId = 'all-secrets-list-back-to-top';
exports.backToTopId = backToTopId;